module.exports = __webpack_public_path__ + "img/Image3.1a9a0026.png";